import { createSlice } from "@reduxjs/toolkit";
import { getPersonalityAssessment, computePersonalityAssessment } from "../actions/personality-assessment-actions";

const initialState = {
  byCandidateId: {},
  loadingByCandidateId: {},
  error: null,
};

const personalityAssessmentSlice = createSlice({
  name: "personalityAssessment",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getPersonalityAssessment.pending, (state, action) => {
        state.loadingByCandidateId[action.meta.arg.candidateId] = true;
      })
      .addCase(getPersonalityAssessment.fulfilled, (state, action) => {
        state.loadingByCandidateId[action.payload.candidateId] = false;
        state.byCandidateId[action.payload.candidateId] = action.payload.data;
      })
      .addCase(getPersonalityAssessment.rejected, (state, action) => {
        state.loadingByCandidateId[action.meta.arg.candidateId] = false;
        state.error = action.payload;
      })
      .addCase(computePersonalityAssessment.fulfilled, (state, action) => {
        state.byCandidateId[action.payload.candidateId] = action.payload.data;
      });
  },
});

const personalityAssessmentSliceReducer = personalityAssessmentSlice.reducer;
export default personalityAssessmentSliceReducer;
